"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CARequestFail = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Modal_1 = require("@skbkontur/react-ui/components/Modal");

var constants_1 = require("../../utils/constants");

var Error_module_css_1 = tslib_1.__importDefault(require("./Error.module.css"));

exports.CARequestFail = function (_a) {
  var phone = _a.phone,
      onClose = _a.onClose;
  return react_1.default.createElement(Modal_1.Modal, {
    width: constants_1.MODAL_WIDTH,
    onClose: onClose
  }, react_1.default.createElement(Modal_1.Modal.Header, null, "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043B\u0438\u0447\u043D\u044B\u0439 \u043A\u0430\u0431\u0438\u043D\u0435\u0442"), react_1.default.createElement(Modal_1.Modal.Body, null, "\u0414\u043B\u044F \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0441\u0435\u0440\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u0432\xA0\u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440", ' ', react_1.default.createElement("span", {
    className: Error_module_css_1.default.nowrap
  }, phone)));
};